import React, { Fragment } from "react";
import { Form, Button, Dimmer, Loader } from "semantic-ui-react";
import { connect } from 'react-redux';

import { completedLibraryControlTranslation, failedLibraryControlTranslation } from "../../../../../actions/library_control";
import useApiService from "../../../../../services/useApiService";
import ControlTranslationIdLabel from "../../../../../components/control_translation_id_label";
import { TranslationLibraryControlDetails } from "../translation_library_control_details";
import { getText } from "../../../../../helpers";

function AiTranslationDetails(props) {
  const { control, language } = props;
  const [{ isLoading, response: translation }, translateControl] = useApiService({
    url: "/library_controls/translate",
    method: "post",
    onSuccess: (data) => {
      const currentLanguage = language.value.toLowerCase();
      const library_control = { ...control, translations: control.translations || {} }
      library_control.translations[currentLanguage] = data;
      props.completedLibraryControlTranslation(library_control, currentLanguage)
    }
  });

  function onSubmit() {
    translateControl({
      library_control_id: control.id,
      translation_type: "ai",
      translation_engine: "openai",
      translation_source: {
        title: control.title,
        subtitle: control.subtitle,
        description: control.description,
        language: "English",
      },
      translation_result: {
        language: language.value,
      },
    });
  }

  const translatedControl = translation && translation.translation_result;

  return (
    <Fragment>
      {!translatedControl && (
        <div className="new-translation-submit">
          <Button positive size="medium" onClick={onSubmit} disabled={isLoading}>
            {getText("Submit")}
          </Button>
        </div>
      )}
      <br />
      <label>{language.text}</label>
      {translatedControl ? (
        <Fragment>
          <Form className="new-translation-section">
            <ControlTranslationIdLabel translation={translation} />
            <TranslationLibraryControlDetails
              control={{
                ...translatedControl,
                id: control.id,
                custom_id: control.custom_id,
              }}
            />
          </Form>
        </Fragment>
      ) : (
        <div className="new-translation-section">
          {getText("Translation details will be shown here.")}
          {isLoading && (
            <Dimmer active inverted>
              <Loader inverted />
            </Dimmer>
          )}
        </div>
      )}
    </Fragment>
  );
}


const mapDispatchToProps = (dispatch) => {
  return {
    completedLibraryControlTranslation: (library_control, language) => {
      dispatch(completedLibraryControlTranslation(library_control, language))
    },
    failedLibraryControlTranslation: (library_control) => {
      dispatch(failedLibraryControlTranslation(library_control))
    }
  }
}

export default connect(null, mapDispatchToProps)(AiTranslationDetails)


// WEBPACK FOOTER //
// ./src/views/control_library/table/tanslations_modal/new_translation_modal/ai_translation_details.js